import { render } from "./FormaPagoForm.vue?vue&type=template&id=a70fbf56&scoped=true"
import script from "./FormaPagoForm.vue?vue&type=script&lang=js"
export * from "./FormaPagoForm.vue?vue&type=script&lang=js"

import "./FormaPagoForm.vue?vue&type=style&index=0&id=a70fbf56&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70fbf56"]])

export default __exports__